import { TITRE_FAMILLE } from '@/components/Dico';

import styles from './styles.module.css';

type Props = {
  titreFamilleContrat: keyof typeof TITRE_FAMILLE;
};

const FamilleContrat = ({ titreFamilleContrat }: Props) => {
  return (
    <div className={styles.contentFamille}>
      <span className={styles.colorFamille}>{TITRE_FAMILLE[titreFamilleContrat]}</span>
    </div>
  );
};
export default FamilleContrat;
